import React, {Component} from 'react';

import DashboardMapWidget from './mapWidget';
import DashboardChatWidget from './chatWidget';
import DashboardChartWidget from './chartWidget';
import DashboardChart2Widget from './chart2Widget';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { IDwFilter } from '../data/Query';
import Editable from 'react-editable-title';


class DashboardWidget extends Component<any, any> {
  private inputRef: any;

  constructor(props: any) {
    super(props);

    this.showWidgetOptions = this.showWidgetOptions.bind(this);
    this.showWidgetOptionDelete = this.showWidgetOptionDelete.bind(this);
    this.widgetToggleFullScreen = this.widgetToggleFullScreen.bind(this);

    this.inputRef = React.createRef();

    this.state = {
      anchorEl: null,
      widgetTitleStatus: '',
      widgetTitle: props.widgetInstance.title,
      map: [],
      layerlist: null,
      config: '',
      setShowWidgetHoverButtons: false,
    };
  }
  
  showWidgetOptions() {
    const { onShowWidgetOptions, widgetInstance } = this.props;
    if (onShowWidgetOptions) {
      onShowWidgetOptions(widgetInstance);
    }
  }

  showWidgetOptionDelete() {
    const { onShowWidgetOptions, widgetInstance } = this.props;
    if (onShowWidgetOptions) {
      onShowWidgetOptions(widgetInstance, "delete");
    }
  }  
  
  widgetToggleFullScreen() {
    const {updateWidgetInstances, widgetTypes, config, widgetInstance, widgetInstances } = this.props;
    console.log("120321 this.props",this.props)
    console.log("120321 config",config)
    console.log("120321 widgetInstance",widgetInstance)
    console.log("120321 widgetInstances",widgetInstances)
    //widgetInstance.height = 20;
    //this.props["data-grid"].minW = 20;
    //this.props["data-grid"].minH = 20;
    if (updateWidgetInstances) {
      updateWidgetInstances(widgetInstances, widgetInstance,  widgetTypes)
    }
  }

  setWidgetTitleStatus(status: string, callback: any) {
    this.setState({
      widgetTitleStatus: status,
    }, callback);
  }   
  
  passMap(payloadObject:any) {
    this.setState({
      map: payloadObject,
    });
    this.props.passMap(payloadObject) // pass map object up to Dashboard
  }    
  
  passLayers(payloadObject:any) {
    this.setState({
      layerList: payloadObject,
    });
    this.props.passLayers(payloadObject) // pass map object up to Dashboard
  }  

  onConfigUpdate(widgetInstanceId:string, config:any) {
    this.props.configUpdate(widgetInstanceId, config);
  }  

  onFilterUpdate(widgetInstanceId:string, filter: IDwFilter) {
    this.props.filterUpdate(widgetInstanceId, filter);
  }

  handleTitleUpdate(current:any) {
    this.props.widgetInstance.title = current;
    this.setState({
      widgetTitle: current
    });
  };

  setShowWidgetHoverButtons(tf:boolean){ 
    this.setState({
      setShowWidgetHoverButtons: tf
    });
  }

  render() {
    const { widgetInstance, widgetInstances, dashboardId, sessionId, widgetTypes, config } = this.props;

    let widgetContent;
    switch(widgetInstance.dashboard_widget_type_id) {
      case 1:
        widgetContent = <DashboardMapWidget 
          widgetInstance={widgetInstance} 
          widgetInstances={widgetInstances} 
          widgetTypes={widgetTypes}
          dashboardId={dashboardId}
          sessionId={sessionId}
          setWidgetTitleStatus={(s: string, c: any) => this.setWidgetTitleStatus(s, c)}
          mapObject={this.state.map} 
          config={config} 
          passMap={(m: any) => this.passMap(m)} //Must bind to 'this' using arrow function
          passLayers={(m: any) => this.passLayers(m)} //Must bind to 'this' using arrow function
          configUpdate={(w:string, c:any) => this.onConfigUpdate(w, c)}
          //configUpdateMaplayer={(w:string, c:any) => this.onConfigUpdateMapLayer(w, c)}
        />;
        break;
      case 2:
        widgetContent = <DashboardChatWidget 
          dashboardId={dashboardId} 
          sessionId={sessionId} 
        />;
        break;
      case 3:
        widgetContent = <DashboardChartWidget 
          widgetInstance={widgetInstance} 
          dashboardId={dashboardId} 
          sessionId={sessionId}
          setWidgetTitleStatus={(s: string, c: any) => this.setWidgetTitleStatus(s, c)} 
        />;
        break;
      case 4:
        widgetContent = <DashboardChart2Widget 
          widgetInstance={widgetInstance} 
          dashboardId={dashboardId} 
          sessionId={sessionId}
          setWidgetTitleStatus={(s: string, c: any) => this.setWidgetTitleStatus(s, c)} 
          config={config}
          configUpdate={(w:string, c:any) => this.onConfigUpdate(w, c)}
          />;
        break;
      default:
        widgetContent  = <div>Unknown Component</div>
          break;
    }
    return (
      <div
        style={{ ...this.props.style }}
        className={"my-component widget " + this.props.className}
        onMouseUp={this.props.onMouseUp}
        onMouseDown={this.props.onMouseDown}
        onTouchStart={this.props.onTouchStart}
        onTouchEnd={this.props.onTouchEnd}  
        onMouseEnter={() => this.setShowWidgetHoverButtons(true)}
        onMouseLeave={() => this.setShowWidgetHoverButtons(false)}
      >
        <div className="widgetTitle">         
          <div className="widgetRemove" onClick={this.showWidgetOptionDelete}>
            { // eslint-disable-next-line
            }<a href="" onClick={(e: any) => e.preventDefault()} >
              <FontAwesomeIcon icon={faTimes} />
            </a>
          </div>
          {/* Uncomment to continue with WIP, full screen widget
          <div className="widgetFullScreen" onClick={this.widgetToggleFullScreen}>
            { // eslint-disable-next-line
            }<a href="" onClick={(e: any) => e.preventDefault()} >
              <FontAwesomeIcon icon={ faExpand } />
            </a>
          </div>*/}
          <Editable
            text={this.state.widgetTitleStatus ? `${widgetInstance.title} - ${this.state.widgetTitleStatus}` : widgetInstance.title}
            saveOnBlur={true}
            placeholder="Type here"
            cb={(c:any) => this.handleTitleUpdate(c)}
          />

          <div className="widgetOptions">
            {/*<Dropdown>
            <Dropdown.Toggle id={`widget-options-${widgetInstance.id}`}><FontAwesomeIcon icon={faCog} /></Dropdown.Toggle>
            <Dropdown.Menu alignRight={true}>
              <Dropdown.Item eventKey="1" onClick={this.showWidgetOptions}>Edit Widget</Dropdown.Item>
              <Dropdown.Divider />
                  <Dropdown.Item eventKey="2">Delete Widget</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>*/}
          </div>
        </div>
        <div className="widgetContents">
          {widgetContent}
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default DashboardWidget;
